import { heroStats } from "@/mocks/home";

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20warm%20amber%20and%20deep%20rust%20glow%20inspired%20by%20a%20dark%20theater%2C%20soft%20light%20streaks%20and%20film%20grain%20texture%2C%20layered%20gradients%2C%20moody%20atmosphere%2C%20artistic%20non%20realistic%20scene%2C%20high%20detail%2C%20clean%20composition&width=1920&height=1200&seq=hero-cinema-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />
      </div>

      <div className="relative w-full max-w-6xl mx-auto px-4 md:px-8 pt-32 pb-16 md:pt-44 md:pb-24">
        <div className="w-full max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 border border-background-50/20 px-3 py-1.5 text-xs md:text-sm text-background-100 font-label">
            <i className="ri-film-line text-primary-300" />
            品牌功能 · APP · 客户端 · 会员与 VIP
          </span>

          <h1 className="mt-6 font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight animate-fade-up">
            茶杯狐影视
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed max-w-2xl animate-fade-up" style={{ animationDelay: '120ms' }}>
            这里集中介绍茶杯狐影视品牌的相关功能：先了解 APP、客户端、会员与 VIP 的使用方式与权益，
            再进一步查看弹幕与收藏等扩展体验。一个页面，把想知道的先看清楚。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 animate-fade-up" style={{ animationDelay: '220ms' }}>
            <a
              href="#app"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium px-6 py-3 whitespace-nowrap transition-colors"
            >
              <i className="ri-download-line" />
              了解 APP 与客户端
            </a>
            <a
              href="#membership"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-background-50/10 hover:bg-background-50/20 border border-background-50/30 text-background-50 text-sm md:text-base font-medium px-6 py-3 whitespace-nowrap transition-colors"
            >
              <i className="ri-vip-crown-line" />
              查看会员与 VIP
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-6 max-w-2xl animate-fade-in" style={{ animationDelay: '320ms' }}>
            {heroStats.map((stat) => (
              <div key={stat.label} className="border-l border-primary-400/50 pl-4">
                <dt className="font-heading text-xl md:text-2xl font-bold text-background-50">
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs md:text-sm text-background-300">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}